__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@rti-scan-app/poc_operational_disruptions";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@dksfrontend/dks-frontend-ui-lib", "0.2.5", () => (Promise.all([__webpack_require__.e(62), __webpack_require__.e(843)]).then(() => (() => (__webpack_require__(8062))))));
			register("@element-plus/icons-vue", "2.3.2", () => (__webpack_require__.e(548).then(() => (() => (__webpack_require__(8548))))));
			register("@vue/apollo-composable", "4.2.2", () => (Promise.all([__webpack_require__.e(211), __webpack_require__.e(733), __webpack_require__.e(907)]).then(() => (() => (__webpack_require__(9733))))));
			register("@vueuse/core", "9.13.0", () => (Promise.all([__webpack_require__.e(410), __webpack_require__.e(907)]).then(() => (() => (__webpack_require__(8410))))));
			register("element-plus", "2.10.7", () => (Promise.all([__webpack_require__.e(157), __webpack_require__.e(797), __webpack_require__.e(779)]).then(() => (() => (__webpack_require__(3157))))));
			register("graphql", "16.13.1", () => (__webpack_require__.e(547).then(() => (() => (__webpack_require__(1547))))));
			register("pinia", "2.3.1", () => (Promise.all([__webpack_require__.e(774), __webpack_require__.e(907)]).then(() => (() => (__webpack_require__(1774))))));
			register("vue-i18n", "11.2.8", () => (() => (__webpack_require__(2543))), 1);
			register("vue-router", "4.5.1", () => (() => (__webpack_require__(5220))), 1);
			register("vue-sonner", "1.3.2", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(734)]).then(() => (() => (__webpack_require__(5390))))));
			register("vue", "3.5.29", () => (() => (__webpack_require__(785))), 1);
			initExternal(7473);
			initExternal(2287);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};